export enum DashboardTileSize {
    Small,
    Medium,
    Large,
}
